import { AppBar, Box, Button, Grid, Toolbar, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";

type ResourcesToolbarProps = {
  onFileUpload: (event: React.FormEvent<HTMLInputElement>) => void;
};

const ResourcesToolbar = ({ onFileUpload }: ResourcesToolbarProps) => {
  return (
    <Box sx={{ borderBottom: `1px solid ${grey["300"]}` }} flexGrow={1}>
      <AppBar position="static" color="transparent" elevation={0}>
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" component="div">
              Resources
            </Typography>
          </Box>
          <Box>
            <Grid container alignItems="center">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  component="label"
                >
                  Upload
                  <input type="file" hidden onChange={onFileUpload} />
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default ResourcesToolbar;
